<template lang="pug">
    v-app.app
        div.app__container.grey.lighten-5
            header-bar
            //- banner-leaderboard
            router-view.app__router
        //- v-footer.blue-grey.darken-2
            v-container
                v-row
                    v-col( cols="12" sm="12" )
                        | This is the footer content
                        br
                        | This is the footer content
                        br
                        | This is the footer content
                        br
                        | This is the footer content
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import HeaderBar from '@/components/HeaderBar';
    import BannerLeaderboard from '@/components/BannerLeaderboard';

    // import List from "@/utility/controllerList.js";
    // console.log( List() );

    export default {
        name: "App",
        components: {
            HeaderBar,
            BannerLeaderboard
        },
        data() {
            return {
                scrollTimer: false
            }
        },
        computed: {
            ...mapGetters([
                'gamepad'
            ])
        },
        mounted() {
            this.scroll();
        },
        methods: {
            ...mapActions([
                'setGamepad',
                'setScroll'
            ]),
            scroll() {
                window.onscroll = () => {
                    clearTimeout( this.scrollTimer );
                    this.setScroll( true );
                    this.scrollTimer = setTimeout(() => {
                        this.setScroll( false );
                    }, 50);
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .app {
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;

        &__container {
            display: flex;
            flex-direction: column;
            min-height: 100vh;
        }

        &__router {
            flex: 1;
            width: 100%;
        }
    }
</style>
